// Single source of truth for how an ortho visit is keyed and shaped before it
// is sent to record_ortho_adjustment_visit. Both surfaces (chairside Doctor
// View and the patient Ortho tab) MUST build the key the same way, or the same
// clinical visit recorded from both places would create two rows / two charges.

// Surface-INDEPENDENT idempotency key. Keyed only on the clinical facts
// (case + appointment + visit type), never on which screen recorded it.
export function buildOrthoVisitIdempotencyKey({ caseId, appointmentId, visitType }) {
  return `ortho:${caseId}:${appointmentId}:${visitType}`;
}

// Maps an ortho visit type (schema: bonding/adjustment/emergency/debonding/
// retention) to a Patient Files ortho stage (schema check: initial/progress/
// final) so uploaded photos file themselves under the right stage.
const ORTHO_STAGE_BY_VISIT_TYPE = {
  bonding: "initial",
  adjustment: "progress",
  emergency: "progress",
  debonding: "final",
  retention: "final",
};

export function orthoStageForVisitType(visitType) {
  return ORTHO_STAGE_BY_VISIT_TYPE[visitType] || "progress";
}
